(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('showEmails', showEmails);

    function showEmails() {
        return {
            restrict        : 'E',
            scope: {
                emails: '=',
                options: '=?'
            },
            controller      : showEmailsCtrl,
            controllerAs    : 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/view-email',
            link: showEmailsLink
        };

        function showEmailsLink() {

        }
    }

    function showEmailsCtrl() {
        const vm = this;
        this.$onInit = function() {
            vm.max = 2;
            vm.showControls = vm.max < vm.emails.length;
            vm.toggleState = false;

            vm.showRecipientsCount = showRecipientsCount;
            vm.showRecipients = showRecipients;
            vm.showShowMore = showShowMore;
            vm.showHide = showHide;
            vm.toggle = toggle;
        }

        function showRecipientsCount() {
            return (vm.showControls) ? !vm.toggleState : false;
        }

        function showRecipients() {
            return (vm.showControls) ? vm.toggleState : true;
        }

        function showShowMore() {
            return (vm.showControls) ? !vm.toggleState : false;
        }

        function showHide() {
            return (vm.showControls) ? vm.toggleState : false;
        }

        function toggle() {
            vm.toggleState = !vm.toggleState;
        }
    }
})();